fx.ns("shared.screens", class ShapeAlbum extends shared.screens.BaseChoiceScreen
{
    constructor()
    {
        super();

        this.showNext = false;
        this.showBack = fx.get("mode") == "creating";

        this.styleChoice = "circle";

        this.containerHeight = 450;

        this.title = fx.text("Choisissez la forme de votre album");

        this.choices =  [  { data : models.ProductBook.SQUARE, asset : fx.get("assets").shapeSquare, name : fx.text("Carré")},
                            { data : models.ProductBook.PORTRAIT, asset : fx.get("assets").shapePortrait, name : fx.text("Portrait")},
                            { data : models.ProductBook.LANDSCAPE, asset : fx.get("assets").shapeLandscape, name : fx.text("Paysage")},
        ];
    }
    
    onChoiceClicked(data)
    {
        this.data.choosedShape = data;
        this.data.event("next-step");
    }
});